import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionTrabajadorCuentaPropia = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionTrabajadorCuentaPropia = () => {
  const [loadingGetInfoDeclaracionTrabajadorCuentaPropia, setLoadingGetInfoDeclaracionTrabajadorCuentaPropia] = useState(false);
  const [successGetInfoDeclaracionTrabajadorCuentaPropia, setSuccessGetInfoDeclaracionTrabajadorCuentaPropia] = useState(false);
  const [errorGetInfoDeclaracionTrabajadorCuentaPropia, setErrorGetInfoDeclaracionTrabajadorCuentaPropia] = useState<any>(null);
  const [dataGetInfoDeclaracionTrabajadorCuentaPropia, setDataGetInfoDeclaracionTrabajadorCuentaPropia] = useState<any>(null);

  const [statusGetInfoDeclaracionTrabajadorCuentaPropia, setStatusGetInfoDeclaracionTrabajadorCuentaPropia] =
    useState<StatusGetInfoDeclaracionTrabajadorCuentaPropia>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionTrabajadorCuentaPropia = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionTrabajadorCuentaPropia(true);
    setSuccessGetInfoDeclaracionTrabajadorCuentaPropia(false);
    setErrorGetInfoDeclaracionTrabajadorCuentaPropia(null);

    try {
      const res = await apiRecord.getInfoDeclaracionTrabajadorCuentaPropia(userId);

      setStatusGetInfoDeclaracionTrabajadorCuentaPropia({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoDeclaracionTrabajadorCuentaPropia(true);
      setDataGetInfoDeclaracionTrabajadorCuentaPropia(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoDeclaracionTrabajadorCuentaPropia({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoDeclaracionTrabajadorCuentaPropia(err);
      console.error("Error en getInfoDeclaracionTrabajadorCuentaPropia:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionTrabajadorCuentaPropia(false);
    }
  };

  return {
    getInfoDeclaracionTrabajadorCuentaPropia,
    loadingGetInfoDeclaracionTrabajadorCuentaPropia,
    successGetInfoDeclaracionTrabajadorCuentaPropia,
    errorGetInfoDeclaracionTrabajadorCuentaPropia,
    dataGetInfoDeclaracionTrabajadorCuentaPropia,
    statusGetInfoDeclaracionTrabajadorCuentaPropia
  };
};

export default useGetInfoDeclaracionTrabajadorCuentaPropia;
